class StepsSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll(".step-wrapper");
  }

  connectedCallback() {
    this.currentWidth = window.innerWidth;
    this.initSlider();

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize.bind(this));
  }

  initSlider() {
    console.log("Initializing slider with slides:", this.slides.length);
    if (this.flkty) {
      this.flkty.destroy();
    }
    if (this.slides.length <= 1) {
      return;
    }
    const options = {
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
    };
    if (this.slides.length > 3 && window.innerWidth >= 1300) {
      options.cellAlign = "left";
      options.contain = true;
      options.groupCells = 3;
      this.flkty = new Flickity(this, options);
    } else if (window.innerWidth < 1300 && window.innerWidth > 768) {
      options.cellAlign = "left";
      options.contain = true;
      options.groupCells = 2;
      this.flkty = new Flickity(this, options);
    } else if (window.innerWidth <= 768) {
      options.cellAlign = "center";
      this.flkty = new Flickity(this, options);
    }
  }

  handleResize() {
    if (this.currentWidth !== window.innerWidth) {
      this.currentWidth = window.innerWidth;
      this.initSlider();
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  customElements.define("steps-slider", StepsSlider);
});